<template>
  <div>
    <span class="primary--text"> Select from the options below: </span>
    <v-btn
      :color="dentate === 'upper' ? 'card' : 'off'"
      width="100%"
      class="px-0 py-11 d-flex align-center elevation-0 mt-2 mb-3 rounded-10"
      style="text-transform: none"
      @click="setDentate('upper')"
    >
      <v-icon size="80" class="ml-5 mr-1">$singlearch</v-icon>
      <v-card-text class="text-left">
        <span class="primary--text font-weight-medium text-body-1">
          Upper Dentate
        </span>
      </v-card-text>
    </v-btn>
    <v-btn
      :color="dentate === 'lower' ? 'card' : 'off'"
      width="100%"
      class="px-0 py-11 d-flex align-center elevation-0 mt-2 mb-3 rounded-10"
      style="text-transform: none"
      @click="setDentate('lower')"
    >
      <v-icon size="80" class="ml-5 mr-1">$lowerarch</v-icon>
      <v-card-text class="text-left">
        <span class="primary--text font-weight-medium text-body-1">
          Lower Dentate
        </span>
      </v-card-text>
    </v-btn>
    <v-btn
      :color="dentate === 'both' ? 'card' : 'off'"
      width="100%"
      class="px-0 py-11 d-flex align-center elevation-0 rounded-10"
      style="text-transform: none"
      @click="setDentate('both')"
    >
      <v-icon size="80" class="ml-5 mr-1">$dualarch</v-icon>
      <v-card-text class="text-left">
        <span class="primary--text font-weight-medium text-body-1">
          Both
        </span>
      </v-card-text>
    </v-btn>
    <v-fade-transition>
      <span v-if="completed" class="primary--text font-weight-bold mt-3 d-block"> Dentate has been set. </span>
    </v-fade-transition>

    <v-fade-transition>
      <v-btn
        v-if="dentate !== null"
        class="btn-primary mt-3"
        @click="handleContinue"
        :loading="loading"
      >
        Continue
      </v-btn>
    </v-fade-transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  name: "ChooseDentate",

  props: ["completed"],

  data() {
    return {
      dentate: null,
      loading: false
    }
  },

  computed: {
    ...mapGetters(["orderDetails"])
  },

  methods: {
    ...mapActions(["setOrderDetails"]),

    async handleContinue() {
      if (this.dentate === null) return

      const dentateOptions = {}
      if (["upper", "both"].includes(this.dentate))
        dentateOptions.upper_options = {...this.orderDetails.upper_options}
      if (["lower", "both"].includes(this.dentate))
        dentateOptions.lower_options = {...this.orderDetails.lower_options}

      this.setOrderDetails({
        ...this.orderDetails,
        dentate: this.dentate,
        ...dentateOptions
      })

      this.$emit("next")
    },

    setDentate(dentate) {
      if (!this.completed) {
        this.dentate = dentate
      }
    }
  }
}
</script>
